import { useQuizData } from "@/hooks/useQuizData";
import parse from "html-react-parser";
import VerifyIcon from "@/assets/icons/verify.svg";
import type { QuizSingleStep } from "@/types/api.types";

const OfferTestimonials = ({ step }: { step: QuizSingleStep }) => {
  const { data } = useQuizData();
  const { testimonials = [], options = [], staticContent } = step ?? {};

  if (!staticContent) return null;

  return (
    <div className="w-full mx-auto">
      <div className="flex flex-col items-center mb-8">
        <span className="text-[64px] font-semibold text-primary leading-[1.125] mb-3">
          {staticContent?.testimonialsRating}
        </span>
        <span className="text-[18px] text-primary leading-none mb-4">
          {staticContent?.testimonialsReviewsCount}{" "}
          {staticContent?.reviewsLabel}
        </span>
        <img src={staticContent?.ratingsStarsUrl || ""} />
      </div>

      <div className="w-full mx-auto flex flex-col items-center">
        {testimonials.map((t) => (
          <div
            key={t.id}
            className="p-4 border rounded-[10px] border-[#E5E7EB] flex flex-col w-full mb-4"
          >
            <div className="flex justify-between flex-row items-center mb-1">
              <span className="text-[14px] text-[#333] leading-[1.42857] font-medium">
                {t.name}
              </span>
              <span className="text-[12px] text-[#333] leading-[1.33333]">
                {t.date}
              </span>
            </div>

            <div className="flex justify-between flex-row items-center">
              <img src={t.rating || ""} className="max-w-24 max-h-4" />
              <div className="flex flex-row items-center gap-1">
                <img src={VerifyIcon} alt="Verify Icon" />
                <span className="text-[12px] text-[#51D0A1] leading-[1.33333]">
                  {staticContent?.verifiedLabel}
                </span>
              </div>
            </div>

            <div className="border-t border-[#E5E7EB] my-4"></div>

            <div className="text-[12px] text-[#333] leading-[1.33333]">
              {parse(t.text || "")}
            </div>
          </div>
        ))}
        <a
          href={data?.settings?.nextLink?.url}
          className="bg-cta hover:bg-cta-hover rounded-[10px] mt-2 w-full max-w-[400px] p-4 text-center text-[16px] font-bold text-white"
        >
          {options?.[0]?.label}
        </a>
      </div>
    </div>
  );
};

export default OfferTestimonials;
